import { render } from "solid-js/web";
import { App } from "~/solidJs/app/MainApp/index";

// import "solid-devtools";

render(() => <App />, document.getElementById("app") as HTMLElement);
